
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import QuestionDto from '@/models/Questions/QuestionDto';
import FormType from '@/models/Forms/FormType';

export default class FormDto extends BaseAgencyScopeEntityDto {
    status = 0;
    name = '';
    type: FormType = FormType.Undefined;
    description = '';
    questions: QuestionDto[] = [];
}